//Report Page 3

import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import BackButton from '../../../components/BackButton';
import MailOpenTableDetails from '../../../components/MailOpenTableDetails';
import Modal from '../../../components/Modal'
import ButtonClickUserLocation from '../../../components/ButtonClickTableDetails';

const AudienceDetailedList = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [mailDet, setMailDet] = useState([]);
    const [showMailContent, setShowMailContent] = useState(false);
    const [filteredDetails, setFilteredDetails] = useState([]);
    const [selectedMailDetails, setSelectedMailDetails] = useState(null);
    const [showMailModal, setShowMailModal] = useState(false);
    const [showButtonModal, setShowButtonModal] = useState(false);
    const [selectedButtonDetails, setSelectedButtonDetails] = useState(null)

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const mailLogId = queryParams.get('mailLogId');
    const BUId = sessionStorage.getItem("BUId");
    const apiUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchAllMailDetails = async () => {
            try {
                const response = await fetch(`${apiUrl}/Report/UserWiseDetailedMailReport?MailLogId=${mailLogId}`);
                if (!response.ok) {
                    throw new Error('Failed to fetch all mail details');
                }

                const data = await response.json();
                setMailDet(data);
                setFilteredDetails(data);
                setLoading(false);
            } catch (error) {
                setError(error.message);
                setLoading(false);
            }
        };
        
        fetchAllMailDetails();
    }, [BUId, mailLogId, apiUrl]);
    
    const handleViewMailContent = (mailBody) => {
        setShowMailContent(true);
    };

    const showMailModalHandler = (mail) => {
        const mailDetails = {
            mailLogId: mail.mailLogId,
            mailOpenCount: mail.mailOpenCount || 0, 
            mailOpenDetails: mail.mailOpenDetails ? mail.mailOpenDetails.map(detail => ({
                clickedOn: detail.clickedOn,
            })) : [],
        };

        setSelectedMailDetails(mailDetails); 
        setShowMailModal(true); 
    };

    const showButtonModalHandler = (url) => {
        setSelectedButtonDetails(url); 
        setShowButtonModal(true);
    };

    const closeModalHandler = () => {
        setShowMailModal(false);
        setSelectedMailDetails(null);
    };

    // Pagination and formatDate functions
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return isNaN(date.getTime()) ? 'Invalid Date' : date.toLocaleString();
    };

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    
    return (
        <div>
            <BackButton />

            <div className="max-w-4xl mx-auto space-y-8 p-6">
                <h1 className="text-3xl font-bold text-gray-900 text-center mb-8">
                    Mail Log Information
                </h1>

                {filteredDetails && filteredDetails.length > 0 && (
                    <div className="bg-white rounded-xl shadow-lg p-6">
                        <h2 className="text-2xl font-semibold text-gray-800 mb-6 border-b pb-2">
                            Basic Mail Details
                        </h2>
                        <div className="space-y-6">
                            {filteredDetails.map((mail, index) => (
                                <div key={index} className="bg-gray-50 p-6 rounded-lg hover:shadow-md transition-all duration-300">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div className="space-y-4">
                                            <div>
                                                <span className="text-sm font-medium text-gray-500 block mb-1">Sender</span>
                                                <p className="text-gray-900">{mail.fromEmail || 'N/A'}</p>
                                            </div>
                                        </div>
                                        <div className="space-y-4">
                                            <div>
                                                <span className="text-sm font-medium text-gray-500 block mb-1">Receiver</span>
                                                <p className="text-gray-900">
                                                    {Array.isArray(mail.toEmail)
                                                        ? mail.toEmail.join(', ')
                                                        : typeof mail.toEmail === 'string'
                                                            ? mail.toEmail.split(',').map(email => email.trim()).join(', ')
                                                            : 'N/A'}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mt-6">
                                        {showMailContent && mail.body && (
                                            <div className="mt-4">
                                                <span className="text-sm font-medium text-gray-500 block mb-1">Mail Content</span>
                                                <iframe
                                                    src={mail.body}
                                                    width="100%"
                                                    height="500px"
                                                    frameBorder="0"
                                                    title="Mail Content"
                                                    className="border border-gray-300 rounded-lg"
                                                />
                                            </div>
                                        )}

                                        {mail.body && !showMailContent && (
                                            <button
                                                onClick={() => handleViewMailContent(mail.body)}
                                                className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
                                            >
                                                View Mail Content
                                            </button>
                                        )}

                                        {loading && <div className="text-gray-600">Loading content...</div>}
                                        {error && <div className="text-red-600">{error}</div>}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {mailDet && mailDet.length > 0 && (
                    <div className="bg-white rounded-xl shadow-lg p-6">
                        <h2 className="text-2xl font-semibold text-gray-800 mb-6 border-b pb-2">
                            Track Mail Details
                        </h2>
                        <div className="space-y-8">
                            {mailDet.map((mail, index) => (
                                <div key={index} className="bg-gray-50 p-6 rounded-lg hover:shadow-md transition-all duration-300">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                                        <div className="bg-white p-4 rounded-lg shadow-sm flex justify-between items-center">
                                            <div>
                                                <span className="text-sm font-medium text-gray-500 block mb-2">Mail Open Count</span>
                                                <p className="text-2xl font-semibold text-gray-900 mt-1">
                                                    {mail.mailOpenCount || 0}
                                                </p>
                                            </div>
                                            <a
                                                className="text-sm text-blue-500 mt-5 mx-auto inline-block hover:underline cursor-pointer"
                                                onClick={() => showMailModalHandler(mail)}
                                            >
                                                View
                                            </a>
                                            <Modal showModal={showMailModal} handleClose={closeModalHandler}>                         
                                                {selectedMailDetails && (
                                                    <MailOpenTableDetails
                                                        mailOpenDetails={selectedMailDetails.mailOpenDetails || []}
                                                        currentPage={currentPage}
                                                        itemsPerPage={itemsPerPage}
                                                        paginate={paginate}
                                                        formatDate={formatDate}
                                                    />
                                                )}
                                            </Modal>
                                        </div>

                                        <div className="bg-white p-4 rounded-lg shadow-sm">
                                            <span className="text-sm font-medium text-gray-500 block">Number of Buttons</span>
                                            <p className="text-2xl font-semibold text-gray-900 mt-1">
                                                {(mail.buttonUrls && mail.buttonUrls.length) || 0}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="space-y-4">
                                        {mail.buttonUrls && mail.buttonUrls.length > 0 && (
                                            <table className="min-w-full table-auto">
                                                <thead>
                                                    <tr className="bg-gray-100 text-left text-sm text-gray-500">
                                                        <th className="py-2 px-4">Button URL</th>
                                                        <th className="py-2 px-4">Click Count</th>
                                                        <th className="py-2 px-4">View Details</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {mail.buttonUrls.map((url, idx) => (
                                                        <tr key={idx}>
                                                            <td className="py-2 px-4">{url.buttonURL}</td>
                                                            <td className="py-2 px-4">{url.clickCount}</td>
                                                            <td className="py-2 px-4">
                                                                {url.clickCount > 0 && (
                                                                    <button
                                                                        onClick={() => showButtonModalHandler(url)} 
                                                                        className="text-blue-500 hover:underline"
                                                                    >
                                                                        View
                                                                    </button>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                    
                                    {showButtonModal && (
                                        <Modal showModal={showButtonModal} handleClose={() => setShowButtonModal(false)}>
                                            {selectedButtonDetails && (
                                                <div className="space-y-4">       
                                                    <ButtonClickUserLocation buttonDetails={selectedButtonDetails} />
                                                </div>
                                            )}
                                        </Modal>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AudienceDetailedList;